'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EDSApplication = require('./EDSApplication');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EDSApplication).default;
  }
});
Object.defineProperty(exports, 'config', {
  enumerable: true,
  get: function get() {
    return _EDSApplication.config;
  }
});
Object.defineProperty(exports, 'cdn', {
  enumerable: true,
  get: function get() {
    return _EDSApplication.cdn;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }